import { createActions } from 'reduxsauce';
import { ProcessingRedirectOptions, RecipientSelectionModeOptions } from './constants';
import { OathRecurringInterval } from 'store/pay/types';

export interface DonatePageState {
  data?: IPage;
  isLoading: boolean;
  error: string | null;
  hasResolved: boolean;
}

export type PagesData = {
  pages: IPage[];
};

export type IPageImageFilenames = {
  principal_logo?: string;
  community_logo?: string;
  optional_media?: string;
};

export type IPage = {
  id: number;
  donation_amounts: number[];
  value: string;
  desc: string;
  page_background: string;
  page_color_text: string;
  wire_enabled?: boolean;
  has_image: boolean;
  has_community_image: boolean;
  has_optional_media: boolean;
  optional_file_arrangement: 'BELOW_PAGE_NAME' | 'BELOW_PAGE_DESCRIPTION';
  custom_disclaimer?: string;
  recipient_details?: {
    [key: string]: {
      header_1?: string;
      header_2?: string;
      summary?: string;
      sections?: RecipientDetailSection[];
    };
  };
  recipient_order_by?: string;
  page_cta: string;
  is_enabled: boolean;
  impact_score_visibility: boolean;
  show_more_visibility: boolean;
  query_str: string;
  page_type: IPageType;
  processing_redirect: ProcessingRedirect;
  page_rating: number;
  client_id?: number;
  client_name?: string;
  de_page: string;
  page_category: string;
  display_fundraising_bar: string;
  display_community_tracker: string;
  fundraising_goal: string;
  learn_more_link: string;
  bottom_url_text?: string;
  raised: string;
  set_query_string: string;
  whitelabeled: boolean;
  paused_misc: object;
  status: string;
  owner: string;
  recipient_ids: string[];
  event_id: string;
  subscription_level: 'BASIC' | 'PREMIUM';
  is_oath_disclaimer_visible: boolean;
  recurring_enabled: boolean;
  recurring_interval: OathRecurringInterval;
  offline_instructions_wire: OfflineInstruction[] | null;
  offline_instructions_check: OfflineInstruction[] | null;
  offline_instructions_grant: OfflineInstruction[] | null;
  optional_media_type?: string | null;
  image_filenames?: IPageImageFilenames;
  allocation_type: IAllocationType;
  recipient_groups: IRecipientGroup[];
  partner_tracking?: {
    meta_id?: string;
    google_ads_id?: string;
    google_analytics_id?: string;
  } | null;
  action_button_alt?: {
    verb?: string;
    noun?: string;
  } | null;
};

export type IPageType = 'LIST' | 'COMPACT' | 'MEDIA' | 'REC';

export type RecipientDetailSection = {
  label: string;
  value: string;
};

export type OfflineInstruction = {
  label: string;
  value: string;
};

export type ProcessingRedirect =
  | ProcessingRedirectOptions.DE_GENERAL
  | ProcessingRedirectOptions.EN_GENERAL
  | ProcessingRedirectOptions.DE_OATH
  | ProcessingRedirectOptions.STRIPE;

export type RecipientSelectionMode =
  | RecipientSelectionModeOptions.CRITERIA_MATCH
  | RecipientSelectionModeOptions.RECIPIENTS_LIST;

export type getDonatePageProps = {
  urlPartner: string;
};

export type IAllocationType = 'EVEN' | 'WEIGHTED' | 'WATERFALL';

export type IRecipientGroup = {
  id: string;
  page_id: number;
  priority: number;
  group_label: string | null;
  weight_percent: number | null;
  recipient_ids: string[];
  donation_limit_cents: number | null;
};

export interface DonatePageTypes {
  DONATE_PAGE: 'DONATE_PAGE';
  DONATE_PAGE_START: 'DONATE_PAGE_START';
  DONATE_PAGE_SUCCESS: 'DONATE_PAGE_SUCCESS';
  DONATE_PAGE_ERROR: 'DONATE_PAGE_ERROR';
  DONATE_PAGE_CLEAN_UP: 'DONATE_PAGE_CLEAN_UP';
}

const { Types, Creators } = createActions<DonatePageTypes>({
  donatePage: ['data'],
  donatePageStart: null,
  donatePageSuccess: ['data'],
  donatePageError: ['error'],
  donatePageCleanUp: null,
});

export { Types };

export default Creators;
